export default {
    prepareDescription(text) {
        return this.shortText(text);
    },
    shortText(text, limit = 2) {
        let firstPart = [];
        let secondPart = [];

        if (!text) {
            return [''];
        }

        let symbols = text.split('.');

        const processingSentence = (i, part) => {
            if (part === 'first') {
                firstPart.push(symbols[i]);
            }

            if (part === 'second') {
                secondPart.push(symbols[i]);
            }
        };

        if (symbols.length > limit) {
            for (let i = 0; i < limit; i++) {
                processingSentence(i, 'first');
            }

            for (let i = limit; i < symbols.length; i++) {
                processingSentence(i, 'second');
            }
        } else {
            for (let i = 0; i < symbols.length; i++) {
                processingSentence(i, 'first');
            }
        }

        return [firstPart.join('.'), secondPart.join('.')];
    },
    generateText(text, count = 2) {
        const sentences = this.splitTextBySentences(text);
        let result = [];
        let str = "";
        for (let i = 0; i <= sentences.length - 1; i++) {
            if (sentences[i] !== "") {
                str += sentences[i] + " ";
            }
            if (i > 0 && (i - 1) % count === 0) {
                result.push(str);
                str = "";
            }
        }

        if (str !== "") {
            result.push(str);
        }

        return result;
    },
    splitTextBySentences(text) {
        text = text.replace("«", '"').replace("»", '"');
        // text = text.replace("т. д.", 'т%%д%%').replace("т.д.", 'т%%д%%').
        //             replace("т. п.", 'т%%п%%').replace("т.п.", 'т%%п%%');

        let rawSentences = text.match(/[^.!?]+[.!?]+["']?|\s*$/g);
        let clearSentences = [];

        for (let i = 0; i < rawSentences.length; i++) {
            // rawSentences[i] = rawSentences[i].replaceAll("%%", ".");

            if (rawSentences[i] === "") {
                continue;
            }
            clearSentences.push(rawSentences[i].trim())
        }

        return clearSentences;
    }
}